import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { FilterOperatorEnum, NotificationBulkFilterDto } from "../../../service/dto";

@Component({
	selector: 'app-filter-info',
	standalone: false,
	templateUrl: './filter-info.component.html',
	styleUrl: './filter-info.component.scss'
})
export class FilterInfoComponent implements OnChanges {
	@Input() displayType?: 'table' | 'card' = 'table';
	@Input() filter!: NotificationBulkFilterDto;
	@Input() filters!: NotificationBulkFilterDto[] | undefined;
	
	filterList: NotificationBulkFilterDto[] = [];

	// constructor() {
	// 	console.log('this.filters', this.filters);
	// 	this.filterList = this.filters ? this.filters : [];
	// 	console.log('this.filterList', this.filterList);
	// }

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['filters']) {
			this.filterList = this.filters ?? [];
			console.log('updated filters', this.filterList);
		}
	}

	getOperatorSymbol(operator: FilterOperatorEnum): string {
		switch (operator) {
			case FilterOperatorEnum.Equal:
				return '=';
			case FilterOperatorEnum.LessThan:
				return '<';
			case FilterOperatorEnum.GreaterThan:
				return '>';
			case FilterOperatorEnum.LessThanEqual:
				return '<=';
			case FilterOperatorEnum.GreaterThanEqual:
				return '>=';
		}
	}

	getValueType(filter: NotificationBulkFilterDto): 'Date' | 'String' | 'DropDownSingle' | 'SelectFromRecords' {
		switch (filter.dataType ) {
			case "Date":
			case "FutureDate":
			case "PastDate":
				return 'Date';
			case "SelectFromRecords":
				return 'SelectFromRecords';
			case "DropDownSingle":
				return 'DropDownSingle';
			default:
				return 'String';
		}
	}
}